
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (Model.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

import { CompanyModel } from './Entities.GormCrm.Company';
import { OrderModel } from './Entities.GormCrm.Order';
import { OrderLineModel } from './Entities.GormCrm.OrderLine';
import { QuestionModel } from './Entities.GormCrm.Question';
import { TaskflowModel } from './Entities.GormCrm.Taskflow';
import { Model, ModelProperty } from 'models/Model';


export class QuestionnaireQuestionReplyModel extends Model<QuestionnaireQuestionReplyModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'id', type: 'guid', languageString: 'questionnaireQuestionReply.property.id', isHidden: true },
		{ name: 'questionId', type: 'guid', languageString: 'questionnaireQuestionReply.property.questionId' },
		{ name: 'companyId', type: 'guid', languageString: 'questionnaireQuestionReply.property.companyId' },
		{ name: 'orderId', type: 'guid', languageString: 'questionnaireQuestionReply.property.orderId' },
		{ name: 'orderLineId', type: 'guid', languageString: 'questionnaireQuestionReply.property.orderLineId' },
		{ name: 'taskflowId', type: 'guid', languageString: 'questionnaireQuestionReply.property.taskflowId' },
		{ name: 'created', type: 'Date', languageString: 'questionnaireQuestionReply.property.created', isHidden: true },
		{ name: 'createdById', type: 'guid', languageString: 'questionnaireQuestionReply.property.createdById' },
		{ name: 'replyData', type: 'string', languageString: 'questionnaireQuestionReply.property.replyData' },
		{ name: 'company', type: 'CompanyModel', languageString: 'questionnaireQuestionReply.property.company', isHidden: true, isObject: true, new: () => { return new CompanyModel }, properties: () => { return CompanyModel.classProperties } },
		{ name: 'order', type: 'OrderModel', languageString: 'questionnaireQuestionReply.property.order', isHidden: true, isObject: true, new: () => { return new OrderModel }, properties: () => { return OrderModel.classProperties } },
		{ name: 'orderLine', type: 'OrderLineModel', languageString: 'questionnaireQuestionReply.property.orderLine', isHidden: true, isObject: true, new: () => { return new OrderLineModel }, properties: () => { return OrderLineModel.classProperties } },
		{ name: 'question', type: 'QuestionModel', languageString: 'questionnaireQuestionReply.property.question', isHidden: true, isObject: true, new: () => { return new QuestionModel }, properties: () => { return QuestionModel.classProperties } },
		{ name: 'taskflow', type: 'TaskflowModel', languageString: 'questionnaireQuestionReply.property.taskflow', isHidden: true, isObject: true, new: () => { return new TaskflowModel }, properties: () => { return TaskflowModel.classProperties } }
	];
	[key: string]: any;
	
	public id?: string;
	public questionId?: string;
	public companyId?: string;
	public orderId?: string;
	public orderLineId?: string;
	public taskflowId?: string;
	public created?: Date;
	public createdById?: string;
	public replyData: string;
	public company?: CompanyModel;
	public order?: OrderModel;
	public orderLine?: OrderLineModel;
	public question?: QuestionModel;
	public taskflow?: TaskflowModel;
    
	constructor(){
		super();
		this.id = undefined;
		this.questionId = undefined;
		this.companyId = undefined;
		this.orderId = undefined;
		this.orderLineId = undefined;
		this.taskflowId = undefined;
		this.created = undefined;
		this.createdById = undefined;
		this.replyData = '';
		this.company = undefined;
		this.order = undefined;
		this.orderLine = undefined;
		this.question = undefined;
		this.taskflow = undefined;
		
	}
	getProperties(){
		return QuestionnaireQuestionReplyModel.classProperties;
	}
}

